var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tile-grid',[(_vm.getService)?_vm._l((_vm.getServicesByIds(_vm.getService.childsIds)),function(service){return _c('service-tile',{key:service.id,attrs:{"selected":false,"service":service}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }